import axios from 'axios';
import type { AuthResponse } from '../types/user';

const apiBase = (): string => process.env.REACT_APP_API_URL ?? '';

export interface OnboardingPreview {
  firstName: string;
  fullName: string;
  phoneHint: string;
  dialCode: string;
  phoneNational: string;
}

export async function fetchOnboardingPreview(token: string): Promise<OnboardingPreview> {
  const { data } = await axios.get<{ data: OnboardingPreview }>(
    `${apiBase()}/onboarding/${encodeURIComponent(token)}`
  );
  return data.data;
}

export async function completeOnboarding(
  token: string,
  payload: { email: string; password: string; dialCode: string; phone: string }
): Promise<AuthResponse> {
  const { data } = await axios.post<AuthResponse>(
    `${apiBase()}/onboarding/${encodeURIComponent(token)}`,
    payload
  );
  return data;
}
